import { AuthService } from './auth.service.js';
import { login } from './login/login.module';
import { resetPassword } from './reset-password/reset-password.module';
import { changePassword } from './change-password/change-password.module';

export const auth = angular
	.module('auth',[ 
		login,
		resetPassword,
		changePassword
	])
	.service('AuthService', AuthService)
    .run(($transitions, $state, AuthService, $location) => {
		'ngInject';

		$transitions.onStart({
			to: 'app.login',
		}, (state) => {
			if (AuthService.isAuthenticated()){
				$state.go('app.dashboard');
				return true;
			}
		});
	})
	.name;



// WEBPACK FOOTER //
// ./src/app/components/auth/auth.module.js